import { BotIcon, Settings } from 'lucide-react'
import { useParams } from 'react-router'

import { SidebarItem } from '@/components/sidebar/types'
import { useSession } from '@/contexts/auth/session'
import useTranslator from '@/hooks/translation'
import { useQueryParams } from '@/hooks/use-query-params'
import { toQueryString } from '@/utils/to-query-string'

export const useMenuItems = (): SidebarItem[] => {
  const {
    state: { isUserAuthenticated },
  } = useSession()

  const params = useParams()

  const projectId = params.projectId!
  const { getQueryParams } = useQueryParams()
  const { getTranslation } = useTranslator()

  const { companyId } = getQueryParams()
  const queryString = toQueryString({
    companyId,
  })

  return [
    {
      index: 0,
      icon: <BotIcon />,
      title: getTranslation('common.bots'),
      path: `/projects/${projectId}/bots?${queryString}`,
      disabled: !isUserAuthenticated,
      hidden: false,
    },
    {
      index: 1,
      icon: <Settings />,
      title: getTranslation('projects.settings'),
      path: `/projects/${projectId}/settings?${queryString}`,
      disabled: !isUserAuthenticated,
      hidden: false,
    },
  ]
}
